export const uk = {
    'age-required': 'Не указан возраст',
    'all-conditions-done': 'Выполнены все условия',
    'all-devices-rate-value': 'Нельзя устанавливать корректировку {value}% на все устройства',
    'all-inventories-rate-value': 'Нельзя устанавливать корректировку {value}% на все типы инвентаря',
    cloudiness: 'Облачность',
    'cloudiness-clear': 'Ясно',
    'cloudiness-hint': 'Облачность - {value}',
    'cloudiness-medium': 'Средняя',
    'cloudiness-overcast': 'Сплошная',
    'cloudiness-partly': 'Небольшая',
    'cloudiness-significant': 'Значительная',
    'equal-items': 'Пересекаются условия № {numbers}. Удалите одно из них или измените настройки.',
    'gender-required': 'Не указан пол',
    'incorrect-max-temperature': 'Максимальная температура не может быть меньше минимальной',
    'intersection-items-warning': {
        one: 'Противоречит условию {list}',
        some: 'Противоречит условиям {list}',
        many: 'Противоречит условиям {list}',
        none: 'Противоречит условиям {list}'
    },
    'max-rate-value': 'Нельзя увеличить ставку более чем на {value}%',
    'min-rate-value': 'Нельзя уменьшить ставку более чем на {value}%',
    'one-condition-done': 'Выполнено хотя бы одно',
    'positive-value': 'Cтавка должна быть целым положительным числом',
    rainfall: 'Осадки',
    'rainfall-average': 'Средние',
    'rainfall-heavy': 'Сильные',
    'rainfall-hint': 'Осадки - {value}',
    'rainfall-light': 'Небольшие',
    'rainfall-none': 'Нет',
    'rainfall-rain-snow': 'Ливень/снегопад',
    'single-mass-rate-empty': 'Не установлена единая ставка',
    temperature: 'Температура',
    'temperature-hint': 'Температура от {minTemperature} до {maxTemperature} °C',
    'traffic-jam-free': 'Нет пробок',
    'traffic-jam-hard': 'Пробки',
    'traffic-jam-light': 'Движение затруднено',
    'traffic-jam-very-hard': 'Серьёзные пробки',
    'value-required': 'Не указана ставка'
};
